module.exports = __webpack_public_path__ + "static/media/mask_experimental.979dc734.png";